export const gitCommit = '227d2ff6'
